import axios from "axios";
import { getFromLocalStorage } from "./storageUtil";
// import { message } from "antd";

export const AnalyticsLink =
  "https://console.firebase.google.com/u/0/project/beauty-spot-be044/analytics/app/android:com.app.beautyspotapp/overview";

const axiosInstance = axios.create({
  baseURL: "https://admin.beautyspotapp.co.uk/api",
  // baseURL: "http://beautyspot.codingcopz.in/api",
  // baseURL: "http://beautyspot-staging.codingcopz.in/api",
  // baseURL: "https://beautyspot-staging.bcoder.online/api",
  // baseURL: "http://199.192.21.220:5001/api",
  timeout: 20000,
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = getFromLocalStorage("admin")?.accessToken;
    if (token) {
      // config.headers["Authorization"] = `Bearer ${token}`;
      config.headers["x-access-token"] = `${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

axiosInstance.interceptors.response.use(
  (response) => {
    // if (response?.data?.message === 'jwt malformed') {
    //   localStorage.clear();
    //   window.location.href = "/auth/login";
    // }
    return response;
  },
  (error) => {
    // Pass the error along to be handled elsewhere
    // if (error.code === "ECONNABORTED") {
    //   message.error("Connection Timed Out");
    // }
    return Promise.reject(error);
  },
);

// export const imgPath = "https://beautyspot-prod.s3.amazonaws.com/dev/";
export const imgPath = "https://beautyspot-prod.s3.amazonaws.com/prod/";
// "https://bcoder-dev-bucket.s3.amazonaws.com/beauty-spot/";

export default axiosInstance;
